import { render } from "./payment_type_tabs.vue?vue&type=template&id=38ee16e4"
import script from "./payment_type_tabs.vue?vue&type=script&lang=js"
export * from "./payment_type_tabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__